import { Box, useTheme } from "@mui/material";
import Link from "next/link";
import React from "react";
export const Logo = ({ logo }) => {
    const theme = useTheme();
    return (React.createElement(Link, { href: "/", style: { display: "flex" } },
        React.createElement(Box, { sx: {
                height: "auto",
                width: {
                    md: theme.spacing(10),
                    lg: theme.spacing(12),
                    xl: theme.spacing(14),
                },
            } }, logo)));
};
//# sourceMappingURL=logo.js.map